import React from "react"
import {
  zoneLibre,
  zoneLibreTitle,
  zoneLibreIndex,
} from "./contenu-libre.module.scss"
import Teleformulaire from "../Teleformulaire/teleformulaire"
import ContentTransformer from "../Transformers/content-transformer"
import PropTypes from "prop-types"
import { useBuildData } from "../../hooks/use-build-data"
import { Title, ZoneLibre } from "./contenu-libre-styled"
import { useContenuLibre } from "./contenu-libre-query"

//-----------------------Parent component---------------------------//

const ContenuLibre = ({ zoneTaxoLibre, isIndex }) => {
  const buildColors = useBuildData().theme_settings.palette
  const data = useContenuLibre()
  const contenusLibre = data.allNodeContenuLibre.edges
  const teleformulaires = data.allNodeTeleformulaires.edges
  const resultTeleform = teleformulaires
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const resultContenuLibre = contenusLibre
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const bothNodes = [resultTeleform, resultContenuLibre]
  const result = bothNodes
    .sort((firstDate, lastDate) => {
      if (firstDate.node.created > lastDate.node.created) return -1
      if (firstDate.node.created < lastDate.node.created) return 1
      return 0
    })
    .shift()
  if (!result) return null
  let zoneLibreColor = "white"
  let zoneLibreClassName = zoneLibre
  if (isIndex) {
    zoneLibreClassName = zoneLibreIndex
    zoneLibreColor = buildColors.a_color_gradients.a_light
    if (zoneTaxoLibre === "zone_accueil_2") {
      zoneLibreColor += "B3"
    }
  }
  let contentZoneLibre = (
    <Teleformulaire zoneLibre={true} teleform={result.node} />
  )
  if (result.node.internal.type === "node__contenu_libre") {
    contentZoneLibre = (
      <>
        <Title className={zoneLibreTitle}>{result.node.title}</Title>
        <ContentTransformer content={result.node.body?.processed} />
      </>
    )
  }
  return (
    <ZoneLibre
      bgColor={zoneLibreColor}
      isIndex={isIndex}
      className={zoneLibreClassName}
    >
      {contentZoneLibre}
    </ZoneLibre>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

ContenuLibre.propTypes = {
  zoneTaxoLibre: PropTypes.string.isRequired,
  isIndex: PropTypes.bool,
}
//-----------------------Prop-Types---------------------------//

export default ContenuLibre
